import { Provider } from 'react-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import store from 'redux/store';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <Main>
        <App />
      </Main>
    </Provider>
    ,
  // </React.StrictMode>
);
